import { useEffect, useMemo } from 'react'

const STORAGE_PREFIX = 'chamii.audio_splitter.state.v1'

export function useAudioSplitterPersistence({
  sourceAudio,
  existingSegments,
  audioUrl,
  setAudioUrl,
  tags,
  setTags,
  segmentMarkers,
  setSegmentMarkers,
  markerMode,
  setMarkerMode,
  autoSplitTargetSec,
  setAutoSplitTargetSec,
  selectedSegmentIndex,
  setSelectedSegmentIndex,
}) {
  const storageKey = useMemo(() => {
    const base = sourceAudio || audioUrl || ''
    return `${STORAGE_PREFIX}:${encodeURIComponent(base)}`
  }, [sourceAudio, audioUrl])

  useEffect(() => {
    if (!sourceAudio || !existingSegments?.length) return
    setTags(existingSegments.map((segment) => ({
      time: segment.start_time || 0,
      hasImage: Boolean(segment.image),
      imageUrl: segment.image || '',
    })))
  }, [sourceAudio, existingSegments, setTags])

  useEffect(() => {
    if (!storageKey) return
    try {
      const state = JSON.parse(localStorage.getItem(storageKey) || 'null')
      if (!state) return
      if (Array.isArray(state.tags)) setTags(state.tags)
      if (state.segmentMarkers && typeof state.segmentMarkers === 'object') setSegmentMarkers(state.segmentMarkers)
      if (typeof state.markerMode === 'boolean') setMarkerMode(state.markerMode)
      if (typeof state.autoSplitTargetSec === 'number') setAutoSplitTargetSec(state.autoSplitTargetSec)
      if (typeof state.selectedSegmentIndex === 'number') setSelectedSegmentIndex(state.selectedSegmentIndex)
      if (state.audioUrl) setAudioUrl(state.audioUrl)
    } catch {
      // Ignore invalid local state.
    }
  }, [storageKey, setAudioUrl, setAutoSplitTargetSec, setMarkerMode, setSegmentMarkers, setSelectedSegmentIndex, setTags])

  useEffect(() => {
    if (!storageKey) return
    try {
      localStorage.setItem(storageKey, JSON.stringify({
        audioUrl,
        tags,
        segmentMarkers,
        markerMode,
        autoSplitTargetSec,
        selectedSegmentIndex,
        ts: Date.now(),
      }))
    } catch {
      // Storage can be unavailable in private browsing.
    }
  }, [storageKey, audioUrl, tags, segmentMarkers, markerMode, autoSplitTargetSec, selectedSegmentIndex])
}
